var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon-star f-22 cr-pointer",class:_vm.estadoColor(_vm.row.estrella),on:{"click":function($event){$event.stopPropagation();return _vm.cambiar_estrella(_vm.row)}}})}
var staticRenderFns = []

export { render, staticRenderFns }